import auth from '@/api/auth';
import account from '@/api/account';

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_ERROR_USER_NOT_FOUND = 'LOGIN_ERROR_USER_NOT_FOUND';
const LOGIN_ERROR_WRONG_PASSWORD = 'LOGIN_ERROR_WRONG_PASSWORD';
const LOGIN_ERROR_EXPIRED_LICENSE = 'LOGIN_ERROR_EXPIRED_LICENSE';
const LOGOUT = 'LOGOUT';
const USER_ACCOUNT = 'USER_ACCOUNT';

const state = {
  isLoggedIn: auth.isLogged(),
  errorUserNotFound: false,
  errorWrongPassword: false,
  errorExpiredLicense: false,
  userAccount: undefined
};

const getters = {
  loginErrorUserNotFound: state => {
    return state.errorUserNotFound;
  },
  loginErrorWrongPassword: state => {
    return state.errorWrongPassword;
  },
  loginErrorExpiredLicense: state => {
    return state.errorExpiredLicense;
  },
  getUserAccount: state => {
    return state.userAccount;
  }
};

const mutations = {
  [LOGIN_SUCCESS] (state) {
    state.isLoggedIn = true;
    state.errorUserNotFound = false;
    state.errorWrongPassword = false;
    state.errorExpiredLicense = false;
  },
  [LOGIN_ERROR_USER_NOT_FOUND] (state) {
    state.isLoggedIn = false;
    state.errorUserNotFound = true;
    state.errorWrongPassword = false;
    state.errorExpiredLicense = false;
  },
  [LOGIN_ERROR_WRONG_PASSWORD] (state) {
    state.isLoggedIn = false;
    state.errorUserNotFound = false;
    state.errorWrongPassword = true;
    state.errorExpiredLicense = false;
    state.pending = false;
  },
  [LOGIN_ERROR_EXPIRED_LICENSE] (state) {
    state.isLoggedIn = false;
    state.errorUserNotFound = false;
    state.errorWrongPassword = false;
    state.errorExpiredLicense = true;
    state.pending = false;
  },
  [LOGOUT] (state) {
    state.isLoggedIn = false;
  },
  [USER_ACCOUNT] (state, userAccount) {
    state.userAccount = userAccount;
  }
};

const actions = {
  login ({commit}, {context, credentials, path}) {
    auth.login(context, credentials).then(() => {
      commit(LOGIN_SUCCESS);
      context.$router.push(path);
    }, error => {
      if (error.bodyText.includes("Expired")) {
        commit(LOGIN_ERROR_EXPIRED_LICENSE);
      } else if (error.status === 400) {
        commit(LOGIN_ERROR_USER_NOT_FOUND);
      } else {
        commit(LOGIN_ERROR_WRONG_PASSWORD);
      }
    });
  },
  logout ({commit}) {
    commit(LOGOUT);
    auth.logout();
  },
  resetPasswordEmail ({commit}, {context, username}) {
    return new Promise((resolve, reject) => {
      auth.resetPasswordEmail(context, username).then(response => {
        resolve(response);
      }, error => {
        if (error.status === 400) {
          commit(LOGIN_ERROR_USER_NOT_FOUND);
        } else {
          reject(error);
        }
      });
    });
  },
  emailVerification ({commit}, {context, verificationToken}) {
    return new Promise((resolve, reject) => {
      auth.emailVerification(context, verificationToken).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  resetPasswordForm ({commit}, {context, user}) {
    return new Promise((resolve, reject) => {
      auth.resetPasswordForm(context, user).then(() => {
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  signin ({commit}, {context, user}) {
    return new Promise((resolve, reject) => {
      auth.signin(context, user).then(() => {
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  retrieveUserAccount ({commit, state}, {context}) {
    return new Promise((resolve) => {
      if (state.isLoggedIn && state.userAccount === undefined) {
        account.getUserAccount(context).then(account => {
          commit(USER_ACCOUNT, account);
          analytics(context, account.username);
          requestUserAccountPoll(context, commit);
          resolve();
        }, () => {
          resolve();
        });
      } else {
        resolve();
      }
    });
  }
};

const requestUserAccountPoll = (context, commit) => {
  const fn = () => {
    account.getUserAccount(context).then(account => {
      commit(USER_ACCOUNT, account);
    });
  };
  setInterval(fn, 15 * 60 * 1000); // 15 minutes
};

const analytics = (context, username) => {
  if (process.env.NODE_ENV === 'production') {
    const ga = context.$ga;
    if (ga) ga.event({eventCategory: 'account', eventAction: username});
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/account/index.js